/**
 * Типы доступных модулей в системе
 */
export type ModuleType = 'discounts' | 'payouts' | 'images' | 'files';

/**
 * Названия модулей для отображения
 */
export const MODULE_NAMES: Record<ModuleType, string> = {
  discounts: 'Скидки',
  payouts: 'Выплаты',
  images: 'Фото',
  files: 'Файлы',
} as const;
